export const path = 2;
export const statusId = 1;
export const drStatusId = "all";
export const incompleteStopsPath = 3;
export const requestStatusId = 5;
export const requestStatusId2 = 2;
export const limitRowCountFlag = "Y";
